import { FunctionComponent } from 'react'
import { Box } from '@black-bear-energy/rucksack'
import { SiteRFPPhaseAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { SiteRFPPhaseChip } from './SiteRFPPhaseChip'
import { ChipScale } from 'components/helpers/getSiteRFPPhaseLabel'

interface SiteRFPPhaseChipsProps {
  phase: SiteRFPPhaseAPIResponse
  scale?: ChipScale
  direction?: 'row' | 'column'
}

/**
 * Renders a chip for the site RFP phase, or two chips for the combined DeriskingAndPermits phase.
 */
export const SiteRFPPhaseChips: FunctionComponent<SiteRFPPhaseChipsProps> = ({
  phase,
  scale = 'medium',
  direction = 'row',
}) => {
  if (phase === SiteRFPPhaseAPIResponse.DeriskingAndPermits) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: direction,
          alignItems: 'flex-start',
          gap: '4px',
        }}
      >
        <SiteRFPPhaseChip
          phase={SiteRFPPhaseAPIResponse.Derisking}
          scale={scale}
        />
        <SiteRFPPhaseChip
          phase={SiteRFPPhaseAPIResponse.Permits}
          scale={scale}
        />
      </Box>
    )
  }

  return <SiteRFPPhaseChip phase={phase} scale={scale} />
}
